<template>
  <!-- 蓝牙升级任务 -->
  <div class="page">
    <!-- 搜索区域 -->
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="auto" class="from">
        <!-- 固件类别 -->
        <el-form-item :label="$t('pages.equipment.text198')">
          <el-select
            v-model="searchParams.hwType"
            :placeholder="$t('public.text5')"
            clearable
          >
            <el-option
              v-for="item in opeting"
              :key="item.label"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text5')">
          <el-select
            v-model="searchParams.bikeCategoryId"
            :placeholder="$t('public.text5')"
            clearable
          >
            <el-option
              v-for="(item, index) in equipmentCategoryList"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text6')">
          <el-select
            v-model="searchParams.bikeTypeId"
            :placeholder="$t('public.text5')"
            clearable
          >
            <el-option
              v-for="(item, index) in equipmentModelList"
              :key="index"
              :label="item.bikeTypeName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text191')">
          <el-date-picker
            v-model="searchParams.startAt"
            type="datetime"
            :placeholder="$t('public.text2')"
            :picker-options="pickerOptions0"
            @change="startChange"
          >
          </el-date-picker>
          <span style="margin: 0 14px">-</span>
          <el-date-picker
            v-model="searchParams.stopAt"
            type="datetime"
            :placeholder="$t('public.text3')"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text192')">
          <el-select
            clearable
            v-model="searchParams.isForce"
            :placeholder="$t('public.text5')"
          >
            <el-option
              v-for="item in isForceList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="searchSubmit">
        <DiluButton
          type="search"
          @click="search"
          v-permission="['bluetoothUpgradeTask:query']"
        ></DiluButton>
        <DiluButton
          type="reset"
          @click="reset"
          v-permission="['bluetoothUpgradeTask:reset']"
        ></DiluButton>
      </div>
    </div>

    <!-- 表格 -->
    <DiluTable
      :list="tableData"
      :tableConfig="tableConfig"
      :pageSize="searchParams.pageSize"
      @currentChange="currentChange"
      :total="total"
    >
      <el-table-column prop="id" label="#" width="40" align="center">
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="startValidTime"
        :label="$t('pages.equipment.text191')"
        width="200"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="isForce"
        :label="$t('pages.equipment.text192')"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.isForce == 0
              ? $t("pages.equipment.text193")
              : $t("pages.equipment.text194")
          }}</span>
        </template>
      </el-table-column>
      <!-- 固件类别 -->
      <el-table-column
        prop="hwType"
        :label="$t('pages.equipment.text198')"
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <span v-for="(item, index) in opeting" :key="index">
              {{ item.value == scope.row.hwType ? item.label : "" }}
            </span>
          </div>
        </template>
      </el-table-column>
      <!-- 硬件版本 -->
      <el-table-column
        prop="hwVersion"
        :label="$t('omission.text71')"
        align="center"
      >
      </el-table-column>
      <!-- 固件版本 -->
      <el-table-column
        prop="fwVersion"
        :label="$t('omission.text72')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="bikeCategoryName"
        :label="$t('pages.equipment.text5')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="bikeTypeName"
        :label="$t('pages.equipment.text6')"
        align="center"
      >
      </el-table-column>

      <el-table-column
        prop="upgradePer"
        :label="$t('pages.equipment.text195')"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.upgradePer }} %</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="address"
        :label="$t('public.text4')"
        align="center"
        width="120px"
      >
        <template slot-scope="scope">
          <div class="table-operation">
            <el-button
              @click="see(scope.row)"
              type="text"
              v-permission="['bluetoothUpgradeTask:see']"
              >{{ $t("button.look") }}</el-button
            >
            <el-button
              v-permission="['bluetoothUpgradeTask:withdraw']"
              @click="withdraw(scope.row)"
              type="text"
              :disabled="scope.row.remark ? true : false"
              >{{ $t("button.withdraw") }}</el-button
            >
          </div>
        </template>
      </el-table-column>
    </DiluTable>
  </div>
</template>


<script>
import DiluButton from "../../../components/pubilc/dilu-button.vue";
import DiluTable from "../../../components/pubilc/dilu-table.vue";
import { mapState } from "vuex";
import { resetDate } from "../../../utils/util/validate";
export default {
  data() {
    return {
      pickerOptions0: {
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < this.searchParams.startAt;
        },
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
             
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      searchParams: {
        belongCustomerId: "",
        hwType: null, //固件类别
        taskType: 1, //任务类型 0灰度 1正式
        upgradeType: 1, //升级方式 蓝牙/4g,1蓝牙 2 4g
        bikeCategoryId: "", //车辆类别id
        bikeTypeId: "", //车辆型号id
        isForce: "", //是否强制 0:不强制 1：强制
        pageNum: 1, //页码
        pageSize: 10, //每页条数
        startAt: "", //查询开始时间
        stopAt: "", //查询结束时间
      },
      dialogVisible: false, //新增编辑弹窗
      tableConfig: {
        isTree: false,
        isPage: true,
      },
      total: 0,
      tableData: [],
      opeting: [
        {
          value: 10,
          label: this.$t("pages.equipment.text178"), //蓝牙
        },
        {
          value: 15,
          label: this.$t("pages.equipment.text202"), //电机控制器
        },
        {
          value: 20,
          label: this.$t("pages.equipment.text203"), //仪表
        },
        {
          value: 25,
          label: this.$t("pages.equipment.text204"), //电池
        },
        {
          value: 30,
          label: this.$t("pages.equipment.text205"), //中央控制器
        },
        {
          value: 35,
          label: this.$t("pages.equipment.text206"), //钢缆锁
        },
        {
          value: 40,
          label: this.$t("pages.equipment.text207"), //电池锁
        },
        {
          value: 45,
          label: this.$t("pages.equipment.text208"), //轮毂锁
        },
      ],
      equipmentCategoryList: [],
      equipmentModelList: [],
      isForceList: [
        {
          value: "1",
          label: this.$t("pages.system.text87"),
        },
        {
          value: "0",
          label: this.$t("pages.system.text88"),
        },
      ],
      isSerch: false, //是否在查询
    };
  },
  components: {
    DiluTable,
    DiluButton,
  },
  computed: {
    ...mapState(["platformData"]),
  },
  mounted() {
    this.UpgradeTaskList();
    this.equipmentModeListAll();
    this.firmwareManagementListAllCategory();
  },
  methods: {
    //搜索
    search() {
      this.isSerch = true; //是否在查询
      this.searchParams.pageNum = 1;
      this.total = 0;
      this.UpgradeTaskList();
    },
    startChange() {
      this.searchParams.stopAt = null;
    },
    //查看任务详情
    see(e) {
      this.$router.push({
        path: "/equipment/firmwareUpdate/formalUpgradeTaskInfo",
        query: {
          id: e.id,
          taskType: 1,
          upgradeType: 1,
        },
      });
    },
    //撤回
    withdraw(e) {
      this.$confirm(
        this.$t("pages.equipment.text196"),
        this.$t("public.text6"),
        {
          confirmButtonText: this.$t("button.determine"),
          cancelButtonText: this.$t("button.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.request.UpgradeTaskDelete(e.id).then(() => {
            this.UpgradeTaskList();
            this.$message({
              type: "success",
              message: this.$t("pages.equipment.text197"),
            });
          });
        })
        .catch(() => {});
    },
    //获取蓝牙升级任务列表
    UpgradeTaskList() {
      this.searchParams.belongCustomerId = this.platformData.id;
      if (this.searchParams.stopAt && this.searchParams.startAt) {
        this.searchParams.stopAt = resetDate(this.searchParams.stopAt); // 结束时间
        this.searchParams.startAt = resetDate(this.searchParams.startAt); // 开始时间
      }
      if (this.searchParams.startAt) {
        if (!this.searchParams.stopAt) {
          return this.$message.error(this.$t("public.text3"));
        }
      }
      if (this.searchParams.stopAt) {
        if (!this.searchParams.startAt) {
          return this.$message.error(this.$t("public.text2"));
        }
      }
      this.request.UpgradeTaskList(this.searchParams).then((res) => {
        this.tableData = res.data.data;
        this.total = res.data.dataMaxCount;
      });
    },
    //车辆型号-查询所有
    equipmentModeListAll() {
      this.request.equipmentModeListAll().then((res) => {
        this.equipmentModelList = res.data;
      });
    },
    //车辆类别-查询所有
    firmwareManagementListAllCategory() {
      this.request.firmwareManagementListAllCategory().then((res) => {
        this.equipmentCategoryList = res.data;
      });
    },
    // 重置
    reset() {
      this.isSerch = false; //是否在查询
      this.searchParams = {
        hwType: null, //固件类别
        taskType: 1, //任务类型 0灰度 1正式
        upgradeType: 1, //升级方式 蓝牙/4g,1蓝牙 2 4g
        bikeCategoryId: "", //车辆类别id
        bikeTypeId: "", //车辆型号id
        isForce: "", //是否强制 0:不强制 1：强制
        pageNum: 1, //页码
        pageSize: 10, //每页条数
        startAt: "", //查询开始时间
        stopAt: "", //查询结束时间
      };
      this.total = 0;
      this.UpgradeTaskList();
    },
    //翻页
    currentChange(e) {
      if (!this.isSerch) {
        this.searchParams = {
          taskType: 1, //任务类型 0灰度 1正式
          upgradeType: 1, //升级方式 蓝牙/4g,1蓝牙 2 4g
          bikeCategoryId: "", //车辆类别id
          bikeTypeId: "", //车辆型号id
          isForce: "", //是否强制 0:不强制 1：强制
          pageNum: 1, //页码
          pageSize: 10, //每页条数
          startAt: "", //查询开始时间
          stopAt: "", //查询结束时间
        };
      }
      this.searchParams.pageNum = e;
      this.UpgradeTaskList();
    },
  },
};
</script>

<style scoped>
.page {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.from {
  float: left;
  display: flex;
}
.searchSubmit {
  float: right;
  display: flex;
}
.operation {
  margin-bottom: 20px;
  display: flex;
}
</style>